import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Admin_mytask() {
    const navigate = useNavigate();
    let trackerWindow = null;
    const [listComanyTaskArrayy, setListComanyTaskArrayy] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {

        var comid = localStorage.getItem('mem_company_id');

        fetch('getAllCompanyTasks.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({ comid: comid })
        })
            .then(response => response.text()) // get raw response first
            .then(result => {
                console.log(result);

                if (result !== 'fail' && result !== '') {
                    let arr;

                    try {
                        arr = JSON.parse(result); // safely parse JSON
                    } catch (e) {
                        console.error("Invalid JSON:", e);
                        arr = [];
                    }

                    let len = Array.isArray(arr) ? arr.length : 0;

                    if (len < 1) {
                        document.querySelector('.notice_text').style.display = 'block';
                        document.getElementById('norecord').style.display = 'block';
                    } else {
                        setListComanyTaskArrayy(arr);
                        
                    }

                } else {
                    showAlert('Cannot found any task for this project.');
                    document.getElementById('norecord').style.display = 'block';
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });


    }, []);

    function checksts() {
        var len = listComanyTaskArrayy.length;
        if (len < 1) {
            $('#norecord').css('display', 'block');
        } else {

        }
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function startwork(tsk_id, pro_id, tskname, tskdetails, pro_name) {
        var userid = localStorage.getItem('member_id');
        var pr_key = tsk_id;
        var tsk_name = tskname;
        var mem_name = localStorage.getItem('membername');
        var company_id = localStorage.getItem('mem_company_id');
        var pid = pro_id;
        var active_pro_name = pro_name;
        var comlohgo = localStorage.getItem('companylogo');

        var comname = localStorage.getItem('mem_company_name');
        var task_details = tskdetails;
        const params = new URLSearchParams({
            task_id: pr_key,
            project_id: pid,
            member_id: userid,
            member_name: mem_name,
            mem_com_id: company_id,
            task_name: tsk_name,
            active_pro_name: active_pro_name,
            comname: comname,
            task_details: task_details,
            comlohgo: comlohgo
        });

        const url = `time_tracker.php?${params.toString()}`;
        if (trackerWindow && !trackerWindow.closed) {
            trackerWindow.focus();
            return;
        }
        trackerWindow = window.open(
            url,
            'timeTrackerWindow',
            'width=420,height=420,resizable=no,alwaysRaised=yes,scrollbars=no,toolbar=no,menubar=no,location=no'
        );
    }

    function getCompleteTasksDetails(pr_key, pro_id) {

        localStorage.setItem('taskid', pr_key);
        localStorage.setItem('taskproid', pro_id);
        navigate('/completetask_details');
    }

    function getTasksDetails(pr_key, pro_id, pro_name) {
        localStorage.setItem('redirectto', 'admintask')
        localStorage.setItem('taskid', pr_key);
        localStorage.setItem('taskproid', pro_id);
        localStorage.setItem('selected_project_name', pro_name);
        localStorage.setItem('selected_project_id', pro_id);
        navigate('/task_details');
    }

    function removeTask(pr_key) {
        var obj = {
            primary_key: pr_key
        };

        fetch('removeProjectTask.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.text()) // IMPORTANT: text(), not json()
            .then(result => {
                console.log(result);

                if (result !== 'fail' && result !== '') {
                    showAlert('Removed successfully');
                    setTimeout(redirectpage, 1500);
                } else {
                    showAlert('Cannot remove task.');
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }
    function redirectpage() {
        navigate('/redirect_admintask');
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
             <Topbar toggleSidebar={toggleSidebar} />
    <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Your tasks</h2>
                    <Link className='pull_right add_new_pro' to="/create_task">Add New Task</Link>


                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_listing_area_grid'>
                        
                        <div className='vl_listing_row nodisplay' id="norecord">
                            <h1 className='notice_text'> No Record Found</h1>
                        </div>
                        {Array.isArray(listComanyTaskArrayy) &&
                            listComanyTaskArrayy.map((item, index) => {
                                const userid = localStorage.getItem('member_id');
                                const isComplete = item.tsk_status === "complete";
                                const creatorid = item.assignById;
                                const adminmember = localStorage.getItem('user_position');
                                const candelete = !isComplete && Number(creatorid) === Number(userid) || adminmember !== 'Member';

                                return (
                                    <div key={index} className="resource_card_one_third_grid" style={{
                                            backgroundColor: isComplete ? "#d4edda" : "transparent", // light green for complete
                                        }}
                                    >
                                        <div className='resource_inner_grid'>
                                        <div className='fullwidth pull_left pt-21'>
                                            <h3>{item.taskname}</h3>
                                             <div className='fullwidth pull_left pb-10'>
                                            <span>Project Name: <b>{item.project_name}</b></span>
                                            <span>Status: {item.tsk_status}</span>
                                            </div>
                                        </div>

                                        <div className="vl_dsh_one_full">
                                            <p>{item.task_details}</p>
                                            <div className="inforow">
                                                <span>Time: {item.assign_time} hrs.</span>
                                                <span>Worked: {item.wordkedhours} hrs.</span>
                                                <span>Status: {item.tsk_status}</span>

                                                <span>

                                                    {!isComplete && (
                                                        <button
                                                            className="startbutton"
                                                            onClick={() => startwork(item.primary_key, item.proj_id, item.taskname, item.task_details, item.project_name)}
                                                        >
                                                            Start Work
                                                        </button>
                                                    )}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="vl_dsh_one_half">
                                            <p>Publish By: {item.assigneBy}</p>
                                        </div>

                                        <div className="list_buttonholder">
                                            {/* Change function based on completion */}
                                            <button
                                                onClick={() => {
                                                    isComplete
                                                        ? getCompleteTasksDetails(item.primary_key, item.proj_id, item.project_name)
                                                        : getTasksDetails(item.primary_key, item.proj_id, item.project_name);
                                                }}
                                            >
                                                Details
                                            </button>

                                            {/* Hide delete button if task is complete */}
                                            {candelete && (
                                                <button
                                                    className="rightgap backtranparent"
                                                    onClick={() => removeTask(item.primary_key)}
                                                >
                                                    <i className="ri-delete-bin-3-fill"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    </div>
                                );
                            })}

                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
